import { getRLSBannerMessages } from '../../../utils/consumer-srories';
import { ConsumerSlidesMessage } from '../../consumer-slides-message';

export const ConsumerStoriesRLSSlideMessage = ({
  onClose,
  onShowMore,
  bannerIndex,
  bannerHeader = 'Retailer lost shoppers',
  getBannerMessageFn = getRLSBannerMessages,
}: {
  onClose?: () => void;
  onShowMore?: () => void;
  bannerIndex?: number;
  bannerHeader?: string;
  getBannerMessageFn?: (market?: string, bannerIndex?: number) => { number: string; message: string } | undefined;
}): JSX.Element => {
  return ConsumerSlidesMessage({ onClose, onShowMore, bannerIndex, bannerHeader, getBannerMessageFn });
};
